
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/freeguide",
      function () {
        return require("private-next-pages/freeguide/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/freeguide"])
      });
    }
  